import { render, staticRenderFns } from "./ComposeButton.vue?vue&type=template&id=8c790018&"
import script from "./ComposeButton.vue?vue&type=script&lang=js&"
export * from "./ComposeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports